import { Controller } from "@hotwired/stimulus"
import { bindMapTarget, unbindMapTarget, resetToBaseLayers } from "../utils/map"

// 地图组件挂载时,把共享的地图单例绑定到当前 #map 元素;离开页面时解绑并恢复初始图层状态。
// 地图本身的创建与图层定义都在 utils/map.js,这里只负责 DOM 生命周期。
export default class extends Controller {
  connect() {
    bindMapTarget(this.element.querySelector("#map"))
  }

  disconnect() {
    resetToBaseLayers()
    unbindMapTarget()
  }
}
